module.exports = __webpack_public_path__ + "static/media/layer3.b5a6ba1b.png";